export default {
    // 'nextgen.bqld.au': { Portal: 'NextGen', Type: 'Player' },
    'ngstaging.bqld.au': { Portal: 'NextGen2', Type: 'Player', Testing: 'true' },
    'nextgen.bqld.au': { Portal: 'NextGen2', Type: 'Player' },
    'fdp.bqld.au': { Portal: 'FDP', Type: 'Player' },
    'nextgencombine.bqld.au': { Portal: 'NextGenCombine', Type: 'Player' },
    'player.ougbigv.au': { Portal: 'BIGV', Type: 'Player' },
    'staff.ougbigv.au': { Portal: 'BIGV', Type: 'Staff' },
    'delegate.ougbigv.au': { Portal: 'BIGV', Type: 'Delegate' },
    'sthplayer.ougnbl1.au': { Portal: 'NBL1', Conference: 3031, Type: 'Player' },
    'sthstaff.ougnbl1.au': { Portal: 'NBL1', Conference: 3031, Type: 'Staff' },
    'sthofficial.ougnbl1.au': { Portal: 'NBL1', Conference: 3031, Type: 'Official' },
    'nthplayer.ougnbl1.au': { Portal: 'NBL1', Conference: 3034, Type: 'Player' },
    'nthstaff.ougnbl1.au': { Portal: 'NBL1', Conference: 3034, Type: 'Staff' },
    'nthofficial.ougnbl1.au': { Portal: 'NBL1', Conference: 3034, Type: 'Official' },
    'westplayer.ougnbl1.au': { Portal: 'NBL1', Conference: 3033, Type: 'Player' },
    'weststaff.ougnbl1.au': { Portal: 'NBL1', Conference: 3033, Type: 'Staff' },
    'westofficial.ougnbl1.au': { Portal: 'NBL1', Conference: 3033, Type: 'Official' },
    'centralplayer.ougnbl1.au': { Portal: 'NBL1', Conference: 3032, Type: 'Player' },
    'centralstaff.ougnbl1.au': { Portal: 'NBL1', Conference: 3032, Type: 'Staff' },
    'centralofficial.ougnbl1.au': { Portal: 'NBL1', Conference: 3032, Type: 'Official' },
    'qslplayer.bqld.au': { Portal: 'QSL', Type: 'Player' },
    'qslstaff.bqld.au': { Portal: 'QSL', Type: 'Staff' },
}
